// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"864e84d6","453":"abd36b29","667":"9a2d07e6","754":"2da52f6e"}[chunkId] + ".chunk.js";
};